var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useGeneratedId } from 'modules/utils';
import { Avatar, AvatarLetter } from 'modules/v2/dataDisplay/Avatar';
import { useAutoHeight } from 'modules/v2/utils/useAutoHeight';
import { StyledTextArea, TextAreaContainer, TextAreaFocusLine } from './styled';
export const ChatInput = forwardRef((props, forwardedRef) => {
    const autoId = useGeneratedId('chatinput');
    const { value, userName, maxHeight = 146, id = autoId } = props, restProps = __rest(props, ["value", "userName", "maxHeight", "id"]);
    const [hasFocus, setHasFocus] = useState(false);
    const textAreaRef = useRef(null);
    useImperativeHandle(forwardedRef, () => textAreaRef.current);
    useAutoHeight({ textAreaRef, textAreaValue: value, minHeight: 16, maxHeight, enabled: true });
    const handleFocus = (event) => {
        setHasFocus(true);
        if (restProps.onFocus) {
            restProps.onFocus(event);
        }
    };
    const handleBlur = (event) => {
        setHasFocus(false);
        if (restProps.onBlur) {
            restProps.onBlur(event);
        }
    };
    const textAreaProps = Object.assign(Object.assign({}, restProps), { id,
        value, onFocus: handleFocus, onBlur: handleBlur, ref: textAreaRef });
    const avatarProps = {
        solid: true,
        size: 'md',
        shape: 'circle',
        appearance: 'cyan',
    };
    return (<TextAreaContainer>
      <Avatar {...avatarProps}>
        <AvatarLetter>{userName.slice(0, 1)}</AvatarLetter>
      </Avatar>
      <TextAreaFocusLine $hasFocus={hasFocus}/>
      <StyledTextArea {...textAreaProps}/>
    </TextAreaContainer>);
});
